import React, {useEffect, useRef, useState} from 'react';
import {Button, Col, Divider, Layout, Modal, Row, Steps, Tooltip} from "antd";
import {Content} from "antd/es/layout/layout";
import img1 from "./imgs/Textura Birch.webp"
import img2 from "./imgs/Textura Black.webp"
import img3 from "./imgs/Textura Pine.webp"
import img4 from "./imgs/Textura Walnut.webp"
import './style.scss'
import bar1 from "./imgs/bar1.png"
import bar2 from "./imgs/bar2.png"
import {FeatureText} from "../Subscription/text";
import {ReactComponent as TickIcon} from "../Subscription/Tick icon.svg"
import {ReactComponent as InfoIcon} from "../Subscription/Information icon.svg"
import SubscriptionEnquiryModal from "./components/SubscriptionEnquiryModal";


const CrossIcon = () => {
    return (
        <div className={'cross-btn'}>x</div>
    )
}
const Shopping = (props) => {
    const [cntBlack, setCntBlack] = useState(0)
    const [cntBirch, setCntBirch] = useState(0)
    const [cntPine, setCntPine] = useState(0)
    const [cntWalnut, setCntWalnut] = useState(0)
    const [curStep, setCurStep] = useState(0)
    const [total, setTotal] = useState(0)
    const [subFee, setSubFee] = useState(0)
    const [sub, setSub] = useState(null)
    const [active, setActive] = useState(
        {
            'Standard': 1,
            'Advanced': 1,
            'Premium': 1
        }
    )
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(() => {
        const sum = cntBirch + cntWalnut + cntPine + cntBlack
        setTotal(sum * 640 + sum * subFee)
    }, [cntBirch, cntBlack, cntPine, cntWalnut, subFee]);
    return (
        <Layout>
            <Content style={{background: '#E8E8E8'}}>
                <Row className={'progress-bar'}></Row>
                <Row justify={"center"}

                     style={{
                         margin: '4rem 0 2rem 0'
                     }}>
                    {curStep === 0 ?
                        <div className="sp-image-container">
                            <img src={bar1}/>
                            <div className="clickable-area-right" onClick={() => setCurStep(1)}></div>
                        </div> :
                        <div className="sp-image-container">
                            <img src={bar2} style={{paddingTop: '1rem'}}/>
                            <div className="clickable-area-left" onClick={() => setCurStep(0)}></div>
                        </div>
                    }

                </Row>
                {curStep === 0 && <Row justify={"center"} className={'t-row'}>
                    <Col lg={5} className={'t-col'}>
                        <div className={'shop-pd-col'}>
                            <img src={img1}/>
                            <p className={'shop-pd-name'}>Birch - £640</p>
                        </div>
                        <div className={'shop-select-div'}>
                            <div className={'shop-select-op'}
                                 onClick={() => cntBirch > 0 && setCntBirch(cntBirch - 1)}
                            >-
                            </div>
                            {cntBirch}
                            <div className={'shop-select-op'}
                                 onClick={() => setCntBirch(cntBirch + 1)}
                            >+
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} className={'t-col'}>
                        <div className={'shop-pd-col'}>
                            <img src={img2}/>
                            <p className={'shop-pd-name'}>Black - £640</p>
                        </div>
                        <div className={'shop-select-div'}>
                            <div className={'shop-select-op'}
                                 onClick={() => cntBlack > 0 && setCntBlack(cntBlack - 1)}
                            >-
                            </div>
                            {cntBlack}
                            <div className={'shop-select-op'}
                                 onClick={() => setCntBlack(cntBlack + 1)}
                            >+
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} className={'t-col'}>
                        <div className={'shop-pd-col'}>
                            <img src={img3}/>
                            <p className={'shop-pd-name'}>Pine - £640</p>
                        </div>
                        <div className={'shop-select-div'}>
                            <div className={'shop-select-op'}
                                 onClick={() => cntPine > 0 && setCntPine(cntPine - 1)}
                            >-
                            </div>
                            {cntPine}
                            <div className={'shop-select-op'}
                                 onClick={() => setCntPine(cntPine + 1)}
                            >+
                            </div>
                        </div>
                    </Col>
                    <Col lg={5} className={'t-col'}>
                        <div className={'shop-pd-col'}>
                            <img src={img4}/>
                            <p className={'shop-pd-name'}>Walnut - £640</p>
                        </div>
                        <div className={'shop-select-div'}>
                            <div className={'shop-select-op'}
                                 onClick={() => cntWalnut > 0 && setCntWalnut(cntWalnut - 1)}
                            >-
                            </div>
                            {cntWalnut}
                            <div className={'shop-select-op'}
                                 onClick={() => setCntWalnut(cntWalnut + 1)}
                            >+
                            </div>
                        </div>
                    </Col>
                </Row>}
                {curStep === 1 &&
                    <Row
                        justify={"center"}
                        style={{
                            columnGap: '6rem',
                            padding: '0 0 3rem 0'
                        }}
                    >
                        <Col className={'sub-option'} lg={6}
                             style={active.Standard === 0 ? {background: ' #D9D9D9', opacity: '0.5'} : {}}
                        >
                            <p className={'sub-opt-title'}>Standard</p>
                            <p className={'sub-opt-subtitle'}>Free</p>
                            <p className={'sub-opt-per-year'}
                                // style={{color: "white"}}
                            >
                                per year</p>
                            <Button className={'shop-sub-opt-btn'}
                                    onClick={() => {
                                        setActive({'Standard': 1, 'Advanced': 0, 'Premium': 0});
                                        setSubFee(0)
                                        setSub('Standard')
                                    }}
                                    disabled={total > 1280}
                            >
                                Standard
                            </Button>
                            <p className={'sub-opt-small-title'}>Standard features:</p>
                            {FeatureText['Standard'].map((txtList, idx) => {
                                return (
                                    <div>
                                        <div className={'sub-features-div'}>
                                            <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                            <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                        </div>
                                        <Divider style={{
                                            marginTop: '-0.3vh'
                                        }}/>
                                    </div>
                                )
                            })}
                        </Col>
                        <Col className={'sub-option'} lg={6}
                             style={active.Advanced === 0 ? {background: ' #D9D9D9', opacity: '0.5'} : {}}
                        >
                            <div className={'sub-most-popular'}>
                                Most popular
                            </div>
                            <p className={'sub-opt-title'}>Advanced</p>
                            <p className={'sub-opt-subtitle'}>£96</p>
                            <p className={'sub-opt-per-year'}>per year</p>
                            <Button className={'shop-sub-opt-btn'}
                                    onClick={() => {
                                        setActive({'Premium': 0, 'Standard': 0, 'Advanced': 1});
                                        setSubFee(100)
                                        setSub('Advanced')
                                    }}
                                    style={{marginBottom: '1rem'}}
                                    disabled={total > 6400}
                            >Advanced</Button>
                            <p className={'sub-opt-small-title'}>Intermediate features:</p>
                            {FeatureText['Advanced'].map((txtList, idx) => {
                                return (
                                    <div>
                                        <div className={'sub-features-div'}>
                                            <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                            <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                        </div>
                                        <Divider style={{
                                            marginTop: '-0.3vh'
                                        }}/>
                                    </div>

                                )
                            })}
                        </Col>
                        <Col className={'sub-option'}
                             lg={6}
                             style={active.Premium === 0 ? {background: '#D9D9D9', opacity: '0.7'} : {}}
                        >
                            <p className={'sub-opt-title'}>Premium</p>
                            <p className={'sub-opt-subtitle'}>POA</p>
                            <p className={'sub-opt-per-year'}>per year</p>
                            <Button className={'shop-sub-opt-btn'}
                                    onClick={() => {
                                        setActive({'Premium': 1, 'Standard': 0, 'Advanced': 0});
                                        setSubFee(0)
                                        setSub('Premium')
                                    }}
                                    style={{marginBottom: '1rem'}}
                            >Premium</Button>
                            <p className={'sub-opt-small-title'}>Advanced features:</p>
                            {FeatureText['Premium'].map((txtList, idx) => {
                                return (
                                    <div>
                                        <div className={'sub-features-div'}>
                                            <span className={'sub-features-inner'}><TickIcon/>{txtList[0]}</span>
                                            <Tooltip title={txtList[1]}><InfoIcon/></Tooltip>
                                        </div>
                                        <Divider style={{
                                            marginTop: '-0.3vh'
                                        }}/>
                                    </div>
                                )
                            })}
                        </Col>
                    </Row>
                }
                <p className={'shop-order-summary'} hidden={total === 0}>Order summary</p>
                <Row justify={"center"} gutter={[32, 32]} hidden={total === 0} style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Col lg={15} className={'order-col'}>
                        {cntPine > 0 && <div className={'shop-pd-col'} style={{marginTop: '15px'}}>
                            <img src={img3} style={{width: '45%'}}/>
                            {/*<CrossIcon></CrossIcon>*/}
                            <p className={'shop-pd-name'}>Pine - £640 x {cntPine}</p>
                        </div>}
                        {cntBlack > 0 &&
                            <div className={'shop-pd-col'} style={{marginTop: '15px'}}>
                                <img src={img2} style={{width: '45%'}}/>
                                <p className={'shop-pd-name'}>Black - £640 x {cntBlack}</p>
                            </div>}
                        {cntBirch > 0 &&
                            <div className={'shop-pd-col'} style={{marginTop: '15px'}}>
                                <img src={img1} style={{width: '45%'}}/>
                                <p className={'shop-pd-name'}>Birch - £640 x {cntBirch}</p>
                            </div>}
                        {cntWalnut > 0 && <div className={'shop-pd-col'} style={{marginTop: '15px'}}>
                            <img src={img4} style={{width: '45%'}}/>
                            <p className={'shop-pd-name'}>Walnut - £640 x {cntWalnut}</p>
                        </div>}
                    </Col>
                    <Col lg={5} className={'order-col order-col-right'}>
                        <div>
                            {sub !== null ? <p className={'shop-sub-txt'}>Subscription:{sub}</p> : ''}
                        </div>
                        <p className={'shop-txt-total'}>Total</p>
                        <p className={'shop-txt-pay-num'}>£{total}</p>
                    </Col>
                </Row>
                <Row justify={"center"} className={'shop-step-row'}>
                    <Button
                        className={'shop-step-btn'}
                        onClick={() => {
                            if (curStep > 0) {
                                setCurStep(curStep - 1)
                            } else {
                                window.location.href = '/business/textura-pro'
                            }
                            setActive({'Premium': 1, 'Standard': 1, 'Advanced': 1});
                            setSub(null)
                        }}
                    >
                        Back
                    </Button>
                    <Button className={'shop-step-btn'}
                            onClick={() => {
                                if (sub !== 'Premium') {
                                    if (curStep === 0) {
                                        if (total > 1280) {
                                            setActive({'Premium': 1, 'Standard': 0, 'Advanced': 1})
                                        }
                                        if (total > 6400) {
                                            setActive({'Premium': 1, 'Standard': 0, 'Advanced': 0})
                                        }
                                    }

                                    var topBlueBar = document.querySelector('.progress-bar');
                                    topBlueBar.scrollIntoView();

                                    setCurStep(curStep + 1)
                                } else {
                                    setIsModalOpen(true)
                                }
                            }}
                            disabled={(curStep === 0 && total === 0) || (curStep === 1 && sub === null)}
                    >
                        Next
                    </Button>
                </Row>
                <SubscriptionEnquiryModal
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                />
            </Content>
        </Layout>
    )
}

export default Shopping;
